/**
 * @Author: wangkai
 * @Date: 2018/9/29
 * @Last Modified by: wangkai
 * @Desc: 请求相关的一些配置文件
 **/
import { server_api } from '@/config/server_api'
export const excludeMessages = [  //全匹配
  'user_token为空',
  '支付密码错误次数超限，请稍后重试',
  '支付密码错误次数超限，请稍后重试',
  '支付密码错误，您还可以输入1次',
  '交易密码过于简单，请重新设置',
  '支付密码错误，您还可以输入2次',
  '交易申请成功,调用连连-交易二次短信验证接口',
  '经销商信息不存在...',
  '签约信息不存在...',
  '请求失败，请重试~',
  '查询失败',
  '请先调用开户绑定手机验证码申请',
  '交易申请成功,调用连连- 交易二次短信验证接口',
  '请开通钱包后再试',
  '超级会员账户不存在',
  '记录不存在',
  '英小树身份已失效，请重新登录',
  '您是老经销商，暂无线上签约文件',
  '没有默认的收货地址'
];

export const errorMsgList = [  //模糊匹配
  '您还不能下单，请联系您的店主',
  "您还不能支付，请联系您的店主"
];
// 请求服务根路径配置
export const serverConfig = server_api();




// WEBPACK FOOTER //
// ./src/api/httpConfig.js